import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false } // 明确标记不需要认证
  },
  {
    path: '/',
    redirect: '/login', // 默认重定向到登录页
  },
  {
    path: '/app',
    redirect: '/versionlst',
    component: () => import('../views/Layout.vue'),
    meta: { requiresAuth: true }, // 标记需要认证
    children: [
      {
        path: '/versionlst',
        name: 'VersionMng',
        component: () => import('../views/VersionMng.vue'),
        meta: { requiresAuth: true } // 标记需要认证
      },
      {
        path: '/loglst',
        name: 'UpdateLogMng',
        component: () => import('../views/UpdateLogMng.vue'),
        meta: { requiresAuth: true } // 标记需要认证
      },
      {
        path: '/account',
        name: 'AccountMng',
        component: () => import('../views/AccountMng.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/customer',
        name: 'CustomerMng',
        component: () => import('../views/CustomerMng.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

// 更灵活的路由守卫
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token')
//   const requiresAuth = to.meta.requiresAuth
  
//   // 如果路由需要认证但用户未登录
//   if (requiresAuth && !token) {
//     // 保存用户原本想访问的页面，登录后可以重定向回来
//     next({
//       path: '/login',
//       query: { redirect: to.fullPath }
//     })
//     return
//   }
  
//   // 如果用户已登录但访问登录页，重定向到首页
//   if (to.path === '/login' && token) {
//     next('/versionlst')
//     return
//   }
  
//   next()
// })

export default router